import SvgSpinner from '@/assets/svgs/spinner'

const Loader = () => (
  <div
    className="relative w-6 h-6 [&_ellipse]:fill-grey-50 [&_circle]:fill-grey-50"
    data-testid="loader-spinner"
  >
    <SvgSpinner className="animate-spin origin-center w-6 h-6" />
  </div>
)

export default Loader
